<template>
  <TrainingAndMentoringProgramSection
    ref="trainingAndMentoringProgram"
  ></TrainingAndMentoringProgramSection>
</template>

<script>
  import TrainingAndMentoringProgramSection from "./TrainingAndMentoringProgramSection.vue";
  import BeforeRouteEnter from "./BeforeRouteEnter.js";

  export default {
    name: "TrainingAndMentoringProgramWrapper",
    components: {
      TrainingAndMentoringProgramSection,
    },
    beforeRouteEnter: BeforeRouteEnter,
  };
</script>
